export default "__VITE_ASSET__hzsWQMB4__"